import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CryptoService} from '../../services/crypto.service';
import { ActivatedRoute } from '@angular/router';
import * as fromStore from '../../store';
import * as fromFeature from '../../my-features';
import { Store } from '@ngrx/store';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SoftwareUpgradeStatus } from '../../shareModel';


@Component({
  standalone: false,
  selector: 'app-gateway-version',
  templateUrl: './gateway-version.component.html',
  styleUrls: ['./gateway-version.component.css']
})
export class GatewayVersionComponent implements OnInit {
  private componentDestroyed = new Subject();
  gatewayVersionData_cols: any[] = [
    { field: 'LastAction', header: TRANSLATE('Last Action'), width: '150', class: 'col-nowrap', disabled: false },
    { field: 'CreateTime', header: TRANSLATE('Time'), width: '200', class: '', disabled: false },
    { field: 'Status', header: TRANSLATE('Result'), width: '200', class: '', disabled: false },
  ];
  gatewayVersionInfo = {
    Id: 0,
    Version: '',
    ReleaseNote: ''
  };
  gatewayVersionData = [];

  constructor(private router: Router,
    private store: Store<fromStore.State>,
    private ngxService: NgxUiLoaderService, 
    private cryptoService: CryptoService, 
    private route: ActivatedRoute) {
    this.ngxService.start();

    const gatewayId = this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('hashId'));
    if (gatewayId) {
      const param = {
        otp: '',
        SWType: 3, // PPG
        SWId: parseInt(gatewayId),

      }
      this.ngxService.start();
      this.store.dispatch(new fromFeature.GetSoftwareVersionData(param));
    }

    this.store.select(fromStore.ReadSoftwareVersionData).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res != null && res !== undefined) {
          this.gatewayVersionInfo = {
            Id: parseInt(gatewayId),
            Version: res.Version,
            ReleaseNote: res.ReleaseNote
          };
          this.gatewayVersionData = [];
          if (res.Logs !== undefined && res.Logs.length > 0) {
            res.Logs.forEach(e => {
              if (e.Status !== undefined && (e.Status === 2 || e.Status === 3)) {
              const item = {
                Status: e.Status == 2 ? 'Success' : 'Failed',
                Version: e.Version,
                CreateTime: parseInt(e.CreateTime),
              }
              this.gatewayVersionData.push(item);
              }
            })
          }
          this.ngxService.stop();
        }
    });
  }

  ngOnInit() {
  }


  backClicked() {
    this.router.navigate(['/gateway-setting/advanced']);
  }

}
